var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_158_1072)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.339844,
    y: 0.80957,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F98365"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1623 61.3796C48.4623 61.3796 46.9823 61.0696 45.7223 60.4496C44.4823 59.8096 43.5323 58.9496 42.8723 57.8696C42.2123 56.7896 41.8823 55.5696 41.8823 54.2096H46.6223C46.6223 55.1296 46.9323 55.8796 47.5523 56.4596C48.1723 57.0196 49.0423 57.2996 50.1623 57.2996C50.9023 57.2996 51.5323 57.1596 52.0523 56.8796C52.5723 56.5996 52.9723 56.2196 53.2523 55.7396C53.5323 55.2396 53.6723 54.6796 53.6723 54.0596C53.6723 53.0996 53.3623 52.3096 52.7423 51.6896C52.1423 51.0696 51.2823 50.7596 50.1623 50.7596C49.5623 50.7596 49.0323 50.8496 48.5723 51.0296C48.1323 51.2096 47.7523 51.4296 47.4323 51.6896L45.2123 47.9396L51.8423 43.6196L51.5723 43.1096H42.7823V38.9096H57.5423V43.4696L49.8923 48.3296L47.4923 47.6696C47.8923 47.5496 48.3123 47.4596 48.7523 47.3996C49.2123 47.3196 49.7023 47.2796 50.2223 47.2796C51.9223 47.2796 53.3823 47.5596 54.6023 48.1196C55.8223 48.6796 56.7623 49.4696 57.4223 50.4896C58.1023 51.4896 58.4423 52.6596 58.4423 53.9996V54.3596C58.4423 55.6996 58.1023 56.8996 57.4223 57.9596C56.7623 59.0196 55.8123 59.8596 54.5723 60.4796C53.3523 61.0796 51.8823 61.3796 50.1623 61.3796Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_158_1072",
    x: 0.339844,
    y: 0.80957,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_158_1072"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.110ee2f5c5c94843259da7b5398377ca.svg";
export { ForwardRef as ReactComponent };